import { ExtendedVue } from 'vue/types/vue'
import elements from '@/config/elements'
import ElementNone from '@/components/elements/ElementNone.vue'

export default {
  // eslint-disable-next-line
  getElementByName: function (elementName: string): ExtendedVue<any, any, any, any, any> {
    if (Object.prototype.hasOwnProperty.call(elements, elementName)) {
      return elements[elementName]
    }
    return ElementNone
  }
}
